import TensaiService from '../../services/tensai';

// actions
export const CREATE_SESSION = 'CREATE_SESSION';
export const UPDATE_SESSION = 'UPDATE_SESSION';
export const DESTROY_SESSION = 'DESTROY_SESSION';
export const FIND_SESSION = 'FIND_SESSION';
export const SIGN_LGPD_DOCUMENTS = 'SIGN_LGPD_DOCUMENTS';

// action: create access
export function createSession(authData, dispatch) {
  const service = new TensaiService();
  const dataPromise = service.createAccess(authData);
  dispatch({ type: CREATE_SESSION, payload: dataPromise });
}

// action: update access
export function updateSession(authData, dispatch, token = null) {
  const service = new TensaiService();
  const dataPromise = service.updateSession(authData, token);
  dispatch({ type: UPDATE_SESSION, payload: dataPromise });
}

// action: destroy access
export function destroySession(dispatch) {
  const service = new TensaiService();
  const dataPromise = service.destroyAccess();
  dispatch({ type: DESTROY_SESSION, payload: dataPromise });
}

// action: get current access
export function refreshCurrentSession(dispatch) {
  const service = new TensaiService();
  const dataPromise = service.getCurrentAccess();
  dispatch({ type: FIND_SESSION, payload: dataPromise });
}

// action: confirma a assinatura LGPD
// Após o POST de assinatura, o interceptor de resposta já gravou o JWT novo
// (need_sign_documents=false); relemos a sessão para baixar a flag no Redux.
export function confirmLgpdSignature(dispatch) {
  const service = new TensaiService();
  const dataPromise = service.getCurrentAccess();
  dispatch({ type: SIGN_LGPD_DOCUMENTS, payload: dataPromise });
}

// action: force logout
export function forceLogout(dispatch) {
  const service = new TensaiService();
  if (service.checkValidateOfCurrentSession(dispatch)) {
    destroySession(dispatch);
    return true;
  }
  return false;
}
